// Per-question verification grade -> a short display label + Tailwind classes.
// Input is one entry from an answer's question_scores: {specificity, correctness, score}.
const STYLE = {
  完全命中: 'bg-[#E6F4EA] text-[#1E7E34] border-[#1E7E34]',
  大致命中: 'bg-[#E7F0FB] text-[#1F6FB2] border-[#1F6FB2]',
  部分命中: 'bg-[#FBF0E0] text-[#B8731B] border-[#B8731B]',
  輕微: 'bg-[#F0EEEA] text-[#7A7468] border-[#C9C2B5]',
  唔中: 'bg-[#FBEAE8] text-[#C93B2B] border-[#C93B2B]',
};

// Aggregate per-request accuracy (0-100) -> a tier label + colours for the meter,
// so a high vs low score reads at a glance (green = 極準 … red = 偏低).
const ACC_TIERS = [
  { min: 85, label: '極準', fill: '#1E7E34', tint: '#E6F4EA' },
  { min: 70, label: '頗準', fill: '#1F6FB2', tint: '#E7F0FB' },
  { min: 50, label: '一般', fill: '#B8731B', tint: '#FBF0E0' },
  { min: 0, label: '偏低', fill: '#C93B2B', tint: '#FBEAE8' },
];

export function accuracyTier(score) {
  const s = Math.max(0, Math.min(100, Math.round(Number(score) || 0)));
  const t = ACC_TIERS.find((x) => s >= x.min) || ACC_TIERS[ACC_TIERS.length - 1];
  return { score: s, label: t.label, fill: t.fill, tint: t.tint };
}

export function questionGrade(score) {
  if (!score) return null;
  if (score.specificity === '空泛') {
    // Barnum / generic — scored 0 regardless of apparent correctness.
    return { label: '空泛／通用', cls: 'bg-[#F0EEEA] text-[#C93B2B] border-[#C9C2B5]' };
  }
  const label = score.correctness === '輕微' ? '輕微沾邊' : score.correctness;
  return { label, cls: STYLE[score.correctness] || 'bg-[#F0EEEA] text-[#5C5C5C] border-[#C9C2B5]' };
}
